import React, { Component } from "react";
import {
  Grid, Segment, Button, Divider,
  Dimmer, Loader, Checkbox, Container,
  Popup, Icon
} from "semantic-ui-react";
import Constants from "../utilities/Constants";
import Strings from "../utilities/StringSelector";
import Utils from "../utilities/Utils";

const UtilsInstance = new Utils();

export class ActiveChannels extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isChannel1Active: false,
      isChannel2Active: false,
      isChannel3Active: false,
      isChannel4Active: false,
      isActiveChannelsDimmerActive: false,
    };
  }

  retrieveData = () => {
    fetch(Constants.REQUEST_IP_ADDRESS + "activeChannels", { mode: "cors" })
      .then(res => res.json())
      .then(data => this.setState({
        isChannel1Active: data.channel1,
        isChannel2Active: data.channel2,
        isChannel3Active: data.channel3,
        isChannel4Active: data.channel4,
      }));
  }

  toggleActiveChannel = (channel) => {
    if (channel === 1) {
      this.setState({ isChannel1Active: !this.state.isChannel1Active });
    }
    else if (channel === 2) {
      this.setState({ isChannel2Active: !this.state.isChannel2Active });
    }
    else if (channel === 3) {
      this.setState({ isChannel3Active: !this.state.isChannel3Active });
    }
    else if (channel === 4) {
      this.setState({ isChannel4Active: !this.state.isChannel4Active });
    }
  }

  handleActiveChannelsSubmit = () => {
    if (this.state.isChannel1Active
      || this.state.isChannel2Active
      || this.state.isChannel3Active
      || this.state.isChannel4Active
    ) {
      this.setState({ isActiveChannelsDimmerActive: true });

      let data = JSON.stringify({
        "channel1": this.state.isChannel1Active,
        "channel2": this.state.isChannel2Active,
        "channel3": this.state.isChannel3Active,
        "channel4": this.state.isChannel4Active,
      });

      fetch(Constants.REQUEST_IP_ADDRESS + "activeChannels_POST", {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        },
        body: data,
        mode: "cors"
      })
        .then(UtilsInstance.checkStatus)
        .then(() => {
          let lowestActiveChannel = -1;
          let firstChannel = -1;

          if (this.state.isChannel1Active === true) {
            if (lowestActiveChannel === -1) {
              lowestActiveChannel = 1;
            }
          }

          if (this.state.isChannel2Active === true) {
            if (lowestActiveChannel === -1) {
              lowestActiveChannel = 2;
            }
          }

          if (this.state.isChannel3Active === true) {
            if (lowestActiveChannel === -1) {
              lowestActiveChannel = 3;
            }
          }

          if (this.state.isChannel4Active === true) {
            if (lowestActiveChannel === -1) {
              lowestActiveChannel = 4;
            }
          }

          firstChannel = parseInt(localStorage.getItem(Constants.ACTIVE_CHANNEL));

          console.log("Updatiando canal depois de enviar. Menor canal era :", firstChannel, " agora é :", lowestActiveChannel);
          localStorage.setItem(Constants.ACTIVE_CHANNEL, lowestActiveChannel);

          alert(Strings.SEND_ACTIVE_CHANNELS_SUCCESS);
          window.location.reload();
        })
        .catch((error) => {
          alert(Strings.SEND_ACTIVE_CHANNELS_ERROR + Strings.ERROR_REASON + error);
        })
        .finally(() => {
          this.setState({ isActiveChannelsDimmerActive: false });
        });
    }
    else {
      alert(Strings.CANT_TURN_ALL_CHANNELS_OFF);
    }
  }

  componentDidMount = () => {
    this.retrieveData();
  }

  render() {
    return (
      <Container text>
        <Segment textAlign="center">
          <Popup position='bottom center' hoverable pinned wide
            trigger={
              <Divider
                horizontal
                style={dividerStyle}>
                {Strings.ACTIVE_CHANNELS}
                <Icon name="question circle" size="big" color="teal" style={questionIconStyle} />
              </Divider>
            }>
            <Popup.Content>
              <p>{Strings.ACTIVE_CHANNELS_POPUP_1}</p>
              <p>{Strings.ACTIVE_CHANNELS_POPUP_2}</p>
            </Popup.Content>
          </Popup >

          <Grid columns={2} centered container textAlign="center" verticalAlign="middle">
            <Grid.Row>
              <Grid.Column textAlign="center" verticalAlign="middle">
                <div>
                  <Checkbox
                    toggle
                    onClick={() => this.toggleActiveChannel(1)}
                    checked={this.state.isChannel1Active}
                    label={Strings.CHANNEL_1} />
                </div>
              </Grid.Column>
              <Grid.Column textAlign="center" verticalAlign="middle">
                <div>
                  <Checkbox
                    toggle
                    onClick={() => this.toggleActiveChannel(2)}
                    checked={this.state.isChannel2Active}
                    label={Strings.CHANNEL_2} />
                </div>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column textAlign="center" verticalAlign="middle">
                <div>
                  <Checkbox
                    toggle
                    onClick={() => this.toggleActiveChannel(3)}
                    checked={this.state.isChannel3Active}
                    label={Strings.CHANNEL_3} />
                </div>
              </Grid.Column>
              <Grid.Column textAlign="center" verticalAlign="middle">
                <div>
                  <Checkbox
                    toggle
                    onClick={() => this.toggleActiveChannel(4)}
                    checked={this.state.isChannel4Active}
                    label={Strings.CHANNEL_4} />
                </div>
              </Grid.Column>
            </Grid.Row>
          </Grid>

          <Button
            color="teal"
            onClick={this.handleActiveChannelsSubmit}>
            {Strings.SAVE}
          </Button>

          <Dimmer active={this.state.isActiveChannelsDimmerActive}>
            <Loader>{Strings.SAVING_ACTIVE_CHANNELS}</Loader>
          </Dimmer>
        </Segment>
      </Container >
    );
  }
}

const dividerStyle = {
  marginTop: "0.5vh"
};

const questionIconStyle = {
  marginLeft: "4px"
};

export default ActiveChannels;